import "./SubNavDropdownContent.scss";

import React, { useContext } from "react";

import { UiStateContext } from "design-system/shared/contexts/ui-state/UiStateContext";

import Box from "@mui/material/Box";

import DescriptiveLinkGroup from "../descriptive-link-group/DescriptiveLinkGroup";
import QuickLinkColumn from "../quick-link-column/QuickLinkColumn";

const SubNavDropdownContent: React.FC = () => {
  const uiStateContext = useContext(UiStateContext);

  const dropDownColumns = uiStateContext.dropDownData && uiStateContext.dropDownData.reference?.length > 0 &&
    uiStateContext?.dropDownData?.reference[0].modular_blocks?.map((subNavBlockItem, index) => {
      if (subNavBlockItem.quick_link_column) {
        return <QuickLinkColumn quickLinkColumn={subNavBlockItem.quick_link_column} key={index} />
      }

      if (subNavBlockItem.descriptive_link_group) {
        return <DescriptiveLinkGroup descriptiveLinkGroup={subNavBlockItem.descriptive_link_group} key={index} />
      }
    });

  return <Box className='sub-nav-dropdown-content'>
    {dropDownColumns}
  </Box>;
};

export default SubNavDropdownContent;
